import styled from "styled-components";

const StyledModalTitle = styled.h3`
    font-weight: 800;
    font-size: 24px;
    color: #1e1e1e;
`;

const StyledModalDiv = styled.div`
    margin: 30px 0;
`;

const StyledCardTag = styled.span`
    display: inline-block;
    background-color: #e4e4e4;
    color: #404040;
    font-size: 16px;
    font-weight: 700;
    padding: 4px 12px;
    border-radius: 6px;
`;

export { StyledModalTitle, StyledModalDiv, StyledCardTag };
